import {
  Box,
  Stack,
  Heading,
  Text,
  Divider,
  List,
  ListItem,
  ListIcon,
} from '@chakra-ui/react';
import { CheckCircleIcon } from '@chakra-ui/icons';
import {
  formatFeature,
  formatGbpFromMinorUnits,
  monthlyAmountMinorUnits,
} from '../../../utils/subscriptionUtils';

const TrialDetailsSubscription = ({ plan }) => {
  return (
    <Box
      borderRadius="xl"
      bg="white"
      px={{ base: 6, md: 8 }}
      py={{ base: 6, md: 8 }}
      boxShadow="sm"
      w="100%"
    >
      <Stack spacing={5}>
        {/* Header row: "Trial" + FREE */}
        <Stack spacing={1}>
          <Text fontSize="xl" fontWeight="semibold">
            Trial
          </Text>
          <Heading size="2xl" lineHeight="0.95">
            FREE
          </Heading>
          <Text>No charge today. Cancel anytime.</Text>
        </Stack>

        <Divider />

        <Stack spacing={8}>
          <Text>
            After your trial, your subscription continues on the{' '}
            <Text as="span" fontWeight="semibold">
              Pilot plan
            </Text>{' '}
            unless you change or cancel.
          </Text>

          <List spacing={2} lineHeight="1.4">
            {plan?.features
              ?.filter((f) => f.key !== 'passentry_watermark')
              .map((f, index) => (
                <ListItem key={index} fontSize="15px">
                  <ListIcon as={CheckCircleIcon} color="orangePrimary" />
                  {formatFeature(f)}
                </ListItem>
              ))}
            <ListItem fontSize="15px">
              <ListIcon as={CheckCircleIcon} color="orangePrimary" />
              Push Notifications
            </ListItem>
            <ListItem fontSize="15px">
              <ListIcon as={CheckCircleIcon} color="orangePrimary" />
              Geofencing
            </ListItem>
            <ListItem fontSize="15px">
              <ListIcon as={CheckCircleIcon} color="orangePrimary" />
              Batch operations
            </ListItem>
          </List>
          <Box>
            <Text fontSize="md">After 14-day trial:</Text>
            <Stack spacing={1} mt={1}>
              <Text fontSize="md">
                <Text as="span" fontSize="xl" fontWeight="semibold">
                  {formatGbpFromMinorUnits(
                    monthlyAmountMinorUnits(plan?.selectedPrice),
                    { wholePounds: true }
                  )}
                </Text>
                <Text as="span" fontSize="sm" fontWeight="normal">
                  {' '}
                  /per month, billed{' '}
                  {plan?.selectedPrice?.interval === 'year'
                    ? 'annually'
                    : 'monthly'}
                </Text>
              </Text>
            </Stack>

            <Text fontSize="sm" mt={1}>
              You can change plans or cancel at any time during the trial.
            </Text>
          </Box>
        </Stack>
      </Stack>
    </Box>
  );
};

export default TrialDetailsSubscription;
